// Spam protection for forms, inserts a value into a field after short delay
$(function() {
  setTimeout(function() {
    var form = $('form.spm-afi');
    form.find("input[name='afi']").val(new Date().getTime());
  }, 750);
});